import React, { useEffect, useState } from "react";
import services from "../../services";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import ComposeEmail from "../../common/ComposeModal";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";


const ShowDraft = () => {
    const [loading, setLoading] = useState(false);
    const [allDraft, setAllDraft] = useState();
    const [ModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [gmailMessageId, setGmailMessageId] = useState("")

    const navigate = useNavigate();

    const getDraft = async () => {
        setLoading(true);
        try {
            const response = await services.draft.GET_ALL_DRAFT();
            setAllDraft(response);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const deleteDraft = async (draftId) => {
        try {
            await services.draft.DELETE_BY_ID_DRAFT(draftId);
            toast.success("Delete successfully");
            getDraft();
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong. Please try again !");
        }
    };

    useEffect(() => {
        getDraft();
    }, []);

    const handleEditClick = async (draft) => {
        try {
            const res = await services.task.GET_TASK_BY_ID(draft);
            const data = res?.data?.data;
            navigate(`/detail/${draft}`, {
                state: {
                    selectedMail: data,
                    deadlineDate: data?.deadline,
                    taskID: draft,
                    clickMailTask: true,
                    type: "Gmail",
                    openTaskDataSidebar: true,
                    currentTask: data,
                },
            });
        } catch (error) {
            console.error("Error fetching Gmail draft:", error);
            toast.error("Failed to load Gmail draft data");
        }
    };

    return (
        <>
            {loading ? (
                <div className="flex items-center justify-center h-full text-[#8696a0] text-lg">
                    <div className="flex items-center gap-2">
                        <span className="loader w-5 h-5 border-2 border-t-transparent rounded-full animate-spin border-[#8696a0]"></span>
                        <span>Loading Draft...</span>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="flex-1">
                        <button
                            onClick={() => navigate("/app")}
                            className="px-4 py-2 font-semibold text-blue-500 bg-white border border-blue-500 rounded-md hover:bg-blue-50"
                        >
                            Back
                        </button>
                    </div>

                    <div className="mx-auto mt-6 border border-gray-200 rounded-lg shadow-sm bg-white">
                        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-50 rounded-t-lg">
                            <h2 className="text-lg font-semibold text-gray-700">Drafts</h2>
                            <span className="text-sm text-gray-500">
                                {allDraft && allDraft?.length} drafts
                            </span>
                        </div>

                        <div className="divide-y divide-gray-200">
                            {allDraft &&
                                allDraft.map((draft) => (
                                    <div
                                        key={draft.id}
                                        className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 group cursor-pointer"
                                    >
                                        <div className="flex items-center space-x-3">
                                            <div className="flex-shrink-0 max-w-[200px] overflow-hidden truncate">
                                                <span className="text-red-600 font-medium">
                                                    Draft,&nbsp;
                                                </span>
                                                <span>{draft.sentTo?.split("@")[0]}</span>
                                            </div>

                                            <span className="text-gray-700 truncate ">
                                                {draft.subject}
                                            </span>
                                        </div>

                                        <div className="flex items-center space-x-3">
                                            <span className="text-sm text-gray-500 group-hover:hidden">
                                                {moment(draft.createdAt).format("MMM D")}
                                            </span>

                                            <div className="hidden group-hover:flex space-x-2">
                                                <button className="p-1 rounded hover:bg-gray-200">
                                                    <MdEdit
                                                        fontSize={20}
                                                        onClick={() => {
                                                            if (draft?.gmailMessageId) {
                                                                handleEditClick(draft.parentTaskID)
                                                            } else {
                                                                setSelectedId(draft?.id);
                                                                setModalOpen(true);
                                                            }
                                                        }}
                                                    />

                                                </button>
                                                <button className="p-1 rounded hover:bg-gray-200">
                                                    <MdDeleteOutline
                                                        fontSize={20}
                                                        onClick={() => {
                                                            deleteDraft(draft?.id);
                                                        }}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                    <div>

                    </div>

                </div>

            )}

            <Modal
                show={ModalOpen}
                onHide={() => setModalOpen(false)}
                size="lg"
                backdrop="static"

            >
                <Modal.Header className="gmail-compose-header">
                    <div className="flex justify-between w-full items-center">
                        <h6 className="m-0">New Message</h6>
                        <div className="flex gap-2">

                            <button
                                className="text-gray-500 hover:text-gray-800"
                                onClick={() => setModalOpen(false)}
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-3 overflow-y-auto ">
                    <ComposeEmail selectedId={selectedId} setModalOpen={setModalOpen} />
                </Modal.Body>
            </Modal>


        </>
    );
};

export default ShowDraft;
